import { module } from 'stereomodularjs';
    
export default class extends module {
    constructor(m) {
        super(m)
        this.alias = ''
        this.touchstartX = 0
        this.touchendX = 0
        this.isChangingSlide = false
        this.activeSlide = false
        this.newActiveSlide = false
        this.slidesActiveIndex = false
        this.nextActiveSlide = false
        this.prevAvticeSlide = false
        this.slideDirection = "to-next"
        this.slideLockDelay = 1210
        this.swipeTrigger = 50
        this.swipeEnabled = true
        this.autoplay = false
        this.autoplayDelay = false
        this.autoplayPause = false
        this.breakpoints =false
        this.curBreakpoint =false
        this.breakpointCurWidth = false
        this.perView = 1
        this.perViewGap = 0
        this.trueSlides = false
        this.BFSlides = this.el.querySelectorAll('[data-bfslider="slide"]')
        this.controlLeft = this.el.querySelector('[data-bfslider="to-prev"]')
        this.controlRight = this.el.querySelector('[data-bfslider="to-next"]')
    }

    init() {

        // Disable if only one slide
        if(this.BFSlides.length == 1){
            classAdd(this.el, 'is-bfslider-disabled')
            return
        }
        // Duplicate slides if only two (need at least 3 to work)
        if(this.BFSlides.length == 2){
            this.el.querySelector('.c-bfslider').innerHTML += this.el.querySelector('.c-bfslider').innerHTML
            this.BFSlides = this.el.querySelectorAll('[data-bfslider="slide"]')
        }

        
        // Check if there's breakpoints then render
        if (this.el.getAttribute('data-bfslider-breakpoints')) {
            if(!this.trueSlides){
                this.trueSlides = this.BFSlides
            }

            let breakpoints = this.el.getAttribute('data-bfslider-breakpoints').split(',')
            for (let i = 0; i < breakpoints.length; i++) {
                breakpoints[i] = breakpoints[i].split(':')
                //let curBreakpoint = [breakpoints[i][0]]
                if (window.innerWidth >= breakpoints[i][0]) {
                    //console.log('breakpoint ' + breakpoints[i][1] + ' cols');
                    this.curBreakpoint = breakpoints[i];
                }
                this.breakpoints = breakpoints
            }
            this.breakpointsRender();

            eventAdd(window,'resize',() => {
                let resizeTimeout;
                clearTimeout(resizeTimeout)
                resizeTimeout = setTimeout(() => {
                    //console.log(window.innerWidth);
                    let isSmall = true
                    for (let i = 0; i < this.breakpoints.length; i++) {
                        if (isSmall && window.innerWidth > this.breakpoints[i][0]){
                            isSmall = false
                        }
                        if (this.curBreakpoint[1] != this.breakpoints[i][1] && 
                            this.curBreakpoint[0] < this.breakpoints[i][0]
                            && window.innerWidth >= this.breakpoints[i][0]
                            ||
                            this.curBreakpoint[1] != this.breakpoints[i][1] && 
                            window.innerWidth < this.curBreakpoint[0] &&
                        this.curBreakpoint[i][0] <= this.curBreakpoint[0]){
                            if(isSmall){
                                this.curBreakpoint = [1,1,'0px']
                                //console.log('is-small')
                            }else{
                                this.breakpoint = this.breakpoints[i]
                            }
                            //console.log(this.breakpoint[1]);
                            this.el.classList.add('is-resizing')
                            this.breakpointsRender('reinit')

                        }
                    }
                }, 250);
            })
        }

        // Assign slides to variables
        this.activeSlide = this.BFSlides[0]
        this.nextActiveSlide = this.BFSlides[1]
        this.prevActiveSlide = this.BFSlides[this.BFSlides.length - 1]
        this.slidesActiveIndex = Array.prototype.indexOf.call(this.BFSlides, this.activeSlide)

        // Set default classes
        classAdd(this.el, this.slideDirection)
        classAdd(this.activeSlide, 'is-active')
        classAdd(this.nextActiveSlide, 'is-next')
        classAdd(this.prevActiveSlide, 'is-prev')
        this.bindControls()

        if(!this.el.getAttribute('data-bfslider-group')){
            let moduleId = this.el.getAttribute('data-mid')
            this.el.setAttribute('data-bfslider-group', 'bfslider-' + moduleId)
        }

        // Build bullets nav if set
        if(this.el.getAttribute('data-bfslider-nav') && this.BFSlides.length > 2){
            this.addNav()
        }

        // Autoplay start if set
        if(this.el.getAttribute('data-bfslider-autoplay')>0 && this.autoplay == false){
            this.autoplayDelay = this.el.getAttribute('data-bfslider-autoplay')
            let groupName = this.el.getAttribute('data-bfslider-group')
            // Autoplay : play the slider and all possible grouped sliders
            this.autoplayControl({ 'groupName': groupName, 'action': 'play' })
        }

        // Swipe event assignation
        if (this.el.getAttribute('data-bfslider-swipe') == 'false') {
            this.swipeEnabled = false
        }
        
        // Add swipe event on selected element
        if (this.swipeEnabled){
            if (this.el.getAttribute('data-bfslider-group') == null || !document.querySelectorAll('[data-bfslider-group="' + this.el.getAttribute('data-bfslider-group') + '"][data-bfslider-swipe="false"]').length) {
                eventAdd(this.el, 'touchstart', (e) => {
                    this.touchstartX = e.changedTouches[0].screenX
                })
                eventAdd(this.el, 'touchend', (e) => {
                    this.touchendX = e.changedTouches[0].screenX
                    this.swipeControl()
                })
            }
        }

        eventAdd(this.el, 'mouseenter', (e) => {
            let groupName = this.el.getAttribute('data-bfslider-group')
            if (groupName) {
                // Autoplay : pause the slider and all possible grouped sliders
                this.call('autoplayControl', { 'groupName': groupName, 'action': 'pause' }, 'BFSlider')
            }
            this.autoplayControl({ 'groupName': groupName, 'action': 'pause' })
        })
        eventAdd(this.el, 'mouseleave', (e) => {
            let groupName = this.el.getAttribute('data-bfslider-group')
            if(this.autoplay){
                if(groupName){
                    // Autoplay : play the slider and all possible grouped sliders
                    this.call('autoplayControl', { 'groupName': groupName, 'action': 'play' }, 'BFSlider')
                }else{
                    this.autoplayControl({ 'groupName': false, 'action': 'play' })
                }
            }
        })
    }

    breakpointsRender(attr){
        //console.log('render '+this.curBreakpoint[1]+' cols');
        if (this.curBreakpoint) {
            let count = 1
            let perView = this.curBreakpoint[1];
            let slides = this.trueSlides
            let gap = this.curBreakpoint[2] || 0;
            let slideWrapper = '<div class="c-bfslider__cols c-bfslider__slide" data-bfslider="slide" style="display:grid;grid-template-columns:repeat(' + perView + ', 1fr);grid-column-gap:' + gap + ';padding:0 calc(' + gap + '/2);margin: 0 calc(-' + gap +' / 2);">'
            let slidesOutput = slideWrapper
            slides.forEach((slide) => {
                let replacedSlide = slide.outerHTML.replace('slide"', 'clone"')
                slidesOutput += replacedSlide
                if (count % perView === 0 && count !== slides.length) {
                    slidesOutput += '</div>' + slideWrapper
                }
                count++
            })
            slidesOutput += '</div>'
            this.el.querySelector('[data-bfslider="slide-wrap"]').innerHTML = slidesOutput
            this.BFSlides = this.el.querySelectorAll('[data-bfslider="slide"]')
        }
        if(attr == 'reinit'){
            this.init()
        }

        setTimeout(() => {
            this.el.classList.remove('is-resizing')
        }, 200);
    }

    // if the slider is in a group, check if the group has the loop option set to false
    isGroupNoLoop(groupName) {
        if (document.querySelectorAll('[data-bfslider-group="' + groupName + '"][data-bfslider-loop="false"]').length > 0) {
            return true
        }
    }

    // Autoplay (stop / pause / play slider and grouped sliders)
    autoplayControl(attr) {
        let groupName = this.el.getAttribute('data-bfslider-group')
        if (attr.groupName && groupName != attr.groupName) return // if groupName is set, only sync if the same group
        //console.log('groupName = ' + groupName + "attr.groupName = " + attr.groupName);
        switch (attr.action) {
            case 'pause':
                clearInterval(this.autoplay)
            break
            case 'stop':
                clearInterval(this.autoplay)
                this.autoplay = null
            break
            case 'play':
                if(!this.autoplayDelay){
                    this.autoplayDelay = document.querySelectorAll('[data-bfslider-group="' + groupName + '"][data-bfslider-autoplay]')[0].getAttribute('data-bfslider-autoplay')
                }
                this.autoplay = setInterval(() => { this.slide({ 'direction': 'to-next' }) }, this.autoplayDelay)
            break
        }   
    }   

    // Return the previous slide (loop)
    getPrevSlide(currentSlide) {
        let getPrevSlide = false
        if (currentSlide.previousElementSibling) {
            getPrevSlide = currentSlide.previousElementSibling
        } else {
            getPrevSlide = this.BFSlides[this.BFSlides.length - 1]
        }
        return getPrevSlide
    }

    // Return the next slide (loop)
    getNextSlide(currentSlide) {
        let getNextSlide = false
        if (currentSlide.nextElementSibling) {
            getNextSlide = currentSlide.nextElementSibling
        } else {
            getNextSlide = this.BFSlides[0]
        }
        return getNextSlide
    }

    // Swipe gesture
    swipeControl() {
        let touchendX = this.touchendX
        let touchstartX = this.touchstartX
        if (touchendX + this.swipeTrigger < touchstartX){
            this.slide({ 'direction': 'to-next', 'stopLoop': true })
        }
        if (touchendX - this.swipeTrigger > touchstartX){
            this.slide({ 'direction': 'to-prev', 'stopLoop': true })
        }
        this.touchendX = 0
        this.touchstartX = 0
    }

    //generate nav buttons (Bullets)
    addNav(){
        let nav = document.createElement('div')
        nav.classList.add('c-bfslider-nav')
        this.el.appendChild(nav)
        // Create bullets
        for(let i = 0; i < this.BFSlides.length; i++){
            let btn = document.createElement('button')
            btn.setAttribute('data-bfslider-nav__btn', i)
            btn.classList.add('c-bfslider-nav__btn')
            btn.setAttribute('aria-label',"Naviguer vers l'élément #" + (i + 1))
            if(i == 0){
                classAdd(btn, 'is-active')
                btn.setAttribute('tabindex', 0)
            }else{
                btn.setAttribute('tabindex', -1)
            }
            nav.appendChild(btn)
            eventAdd(btn, 'keydown',(e)=>{
                this.browse(e)
            })
            // add event to click and keydown for browsing
            eventAdd(btn, 'click', () => {
                this.setActiveSlide(i)
            })
        }
    }

    // Browser active bullet left/right
    browse(el){
        let navBtns = this.el.querySelectorAll('[data-bfslider-nav__btn]')
        let curEl = el.currentTarget
        let lastBtn = navBtns[navBtns.length - 1]
        if (el.key === 'ArrowRight' || el.key === 'ArrowLeft') {
            curEl.setAttribute("tabindex", -1)
            if (el.key === 'ArrowRight') {
                if (curEl.nextElementSibling) {
                    curEl.nextElementSibling.setAttribute("tabindex", 0)
                    curEl.nextElementSibling.focus()
                } else {
                    navBtns[0].setAttribute("tabindex", 0)
                    navBtns[0].focus()
                }
            }
            if (el.key === 'ArrowLeft') {
                if (curEl.previousElementSibling) {
                    curEl.previousElementSibling.setAttribute("tabindex", 0)
                    curEl.previousElementSibling.focus()
                } else {
                    lastBtn.setAttribute("tabindex", 0)
                    lastBtn.focus()
                }
            }
        }
    }

    // Bind arrows
    bindControls() {
        if (this.controlLeft) {
            eventAdd(this.controlLeft, 'click', () => {
                this.slide({'direction': 'to-prev', 'stopLoop': true})
            })
        }
        if (this.controlRight) {
            eventAdd(this.controlRight, 'click', () => { 
                this.slide({ 'direction': 'to-next', 'stopLoop': true })
            })
        }
    }

    // Slide trigger
    slide(attr) {
        let groupName = this.el.getAttribute('data-bfslider-group')
        let newSlide = 0
        if (!this.isChangingSlide){

            if(attr.stopLoop){
                // Autoplay : stop the slider and all possible grouped sliders
                this.call('autoplayControl', { 'groupName': groupName, 'action': 'stop' }, 'BFSlider')
            }

            // Void if first slide and loop is disabled
            if(attr.direction == 'to-prev' 
            && this.slidesActiveIndex == 0 
            && this.isGroupNoLoop(groupName) || 
            attr.direction == 'to-next' 
            && this.slidesActiveIndex == this.BFSlides.length - 1 
            && this.isGroupNoLoop(groupName)){
                return
            }

            // Lock and call new slide
            this.isChangingSlide = true
            this.slideDirection = attr.direction
            
            if (attr.direction == 'to-prev') {
                newSlide = Array.prototype.indexOf.call(this.BFSlides, this.getPrevSlide(this.activeSlide))
            }else{
                newSlide = Array.prototype.indexOf.call(this.BFSlides, this.getNextSlide(this.activeSlide))
            }
            
            if (groupName) {
                this.call('sync', { 'action': 'arrow', 'direction': this.slideDirection, 'newposition': newSlide, 'groupName': groupName }, 'BFSlider')
            }
            this.sync({ 'action': 'arrow', 'direction': this.slideDirection, 'newposition': newSlide })
        }
    }

    // Set Active slide from clicked/touched bullet nav
    setActiveSlide(index) {
        let groupName = this.el.getAttribute('data-bfslider-group')

        if (index != this.slidesActiveIndex && !this.isChangingSlide){

            // Autoplay : stop the slider and all possible grouped sliders
            this.call('autoplayControl', { 'groupName': groupName, 'action': 'stop' }, 'BFSlider')
            
            // assign direction
            if (index < this.slidesActiveIndex) {
                this.slideDirection = "to-prev"
            } else {
                this.slideDirection = "to-next"
            }
            // set classes for clicked bullet
            let newSlide = index
            if (groupName) {
                this.call('sync', { 'action': 'nav', 'direction': this.slideDirection, 'newposition': newSlide, 'groupName': groupName }, 'BFSlider')
            }
            this.sync({ 'action': 'nav', 'direction': this.slideDirection, 'newposition': newSlide })
        }
    }

    // Update the current active slide index
    updateActiveIndex(currentSlide){
        this.slidesActiveIndex = Array.prototype.indexOf.call(this.BFSlides, currentSlide)
    }

    // Slide animation logics from arrows and bullets
    sync(attr){
        let groupName = this.el.getAttribute('data-bfslider-group')
        if (attr.groupName && groupName != attr.groupName) return // if groupName is set, only sync if the same group
        this.isChangingSlide = true // Lock the slider
        this.slideDirection = attr.direction
        this.newActiveSlide = this.BFSlides[attr.newposition]

        // Bullets logic
        if (attr.action == 'nav') {
            if (this.slideDirection == "to-prev") {
                // Slide IN = active will be the PREV slide
                classRemove(this.BFSlides, 'is-next')
                classRemove(this.BFSlides, 'is-prev')
                this.prevActiveSlide = this.newActiveSlide
                classAdd(this.prevActiveSlide, 'is-prev')
                // Slide OUT = NEXT slide going out
                this.nextActiveSlide = this.activeSlide
            }else{
                // Slide IN = active will be the NEXT slide
                classRemove(this.BFSlides, 'is-prev')
                classRemove(this.BFSlides, 'is-next')
                this.nextActiveSlide = this.newActiveSlide
                classAdd(this.nextActiveSlide, 'is-next')
                // Slide OUT = PREV slide going out
                this.prevActiveSlide = this.activeSlide
            }

            setTimeout(() => {
                // Assign new active slide
                this.activeSlide = this.newActiveSlide
                // Animation class
                classAdd(this.el, 'is-sliding')
				classAdd(this.el, '-bullet')

                // Remove states classes
                classRemove(this.BFSlides, 'is-active')
                classRemove(this.BFSlides, 'is-next')
                classRemove(this.BFSlides, 'is-prev')

                // Add states classes
                if (this.slideDirection == "to-prev") {
                    classAdd(this.activeSlide, 'is-active')
                    classAdd(this.nextActiveSlide, 'is-next')
                }
                else {
                    classAdd(this.activeSlide, 'is-active')
                    classAdd(this.prevActiveSlide, 'is-prev')
                }

                // Set Active index & reset lock
                this.updateActiveIndex(this.newActiveSlide)
                this.resetLock()
            }, 20)
        }
        // Arrows logic
        if (attr.action == 'arrow'){
            // Set direction class
            classRemove(this.el, 'to-prev')
            classRemove(this.el, 'to-next')
            classAdd(this.el, this.slideDirection)

            if (this.slideDirection == "to-prev") {
                // -1 slide
                this.newActiveSlide = this.getPrevSlide(this.activeSlide)
            } else {
                // +1 slide
                this.newActiveSlide = this.getNextSlide(this.activeSlide)
            }

            this.updateActiveIndex(this.newActiveSlide)

            // Set next/prev classes to fix animation from bullets
            classRemove(this.BFSlides, 'is-next')
            classRemove(this.BFSlides, 'is-prev')
            classAdd(this.getPrevSlide(this.activeSlide), 'is-prev')
            classAdd(this.getNextSlide(this.activeSlide), 'is-next')

            // Update ext/prev slides assignation
            this.prevActiveSlide = this.getPrevSlide(this.newActiveSlide)
            this.nextActiveSlide = this.getNextSlide(this.newActiveSlide)

            setTimeout(() => {
                // Assign new active slide
                this.activeSlide = this.newActiveSlide
                // Animation class
                classAdd(this.el, 'is-sliding')
				classAdd(this.el, '-arrow')
                // Remove states classes
                classRemove(this.BFSlides, 'is-active')
                classRemove(this.BFSlides, 'is-next')
                classRemove(this.BFSlides, 'is-prev')
                // add new classes
                classAdd(this.activeSlide, 'is-active')
                classAdd(this.nextActiveSlide, 'is-next')
                classAdd(this.prevActiveSlide, 'is-prev')
                // Set Active index
            }, 20)
            this.resetLock()
        }
        // reset lock & animation
    }

    // Reset lock & animation, set active bullet on slider or group sliders
    resetLock() {
        setTimeout(() => {
            classRemove(this.el, 'is-sliding')
			classRemove(this.el, '-bullet')
			classRemove(this.el, '-arrow')
            this.isChangingSlide = false
            this.newActiveSlide = false
        }, this.slideLockDelay)

        // Set active bullet if nav is enabled
        if (this.el.getAttribute('data-bfslider-nav')) {
            let navBtns = this.el.querySelectorAll('[data-bfslider-nav__btn]')
            classRemove(navBtns, 'is-active')
            classAdd(navBtns[this.slidesActiveIndex], 'is-active')
        }
        if (document.querySelector('[data-bfslider-group="' + this.el.getAttribute('data-bfslider-group') + '"][data-bfslider-nav]')){
            let navBtns = this.el.querySelectorAll('[data-bfslider-group="' + this.el.getAttribute('data-bfslider-group') + '"][data-bfslider-nav] [data-bfslider-nav__btn]')
            classRemove(navBtns, 'is-active')
            classAdd(navBtns[this.slidesActiveIndex], 'is-active')
        }
    }

    // bye bye
    destroy() {
        super.destroy()
        //this.unbindEvents()
        if (this.controlLeft) {
            eventRemove(this.controlLeft, 'click')
        }
        if (this.controlRight) {
            eventRemove(this.controlRight, 'click')
        }
        if (this.swipeEnabled) {
            eventRemove(this.el, 'touchstart')
            eventRemove(this.el, 'touchend')
        }
        let navButtons = this.el.querySelectorAll('.c-bfslider-nav__btn')
        if(navButtons.length){
            navButtons.forEach(button => {
                eventRemove(button, 'click')
                eventRemove(button, 'keydown')
            })
        }
    }
}

/* Usage */

/*
BASIC : 
<div class="c-bfslider-wrap" data-module="BFSlider">
    <div class="c-bfslider">
        <div class="c-bfslider__slide" data-bfslider="slide">
            <span>1</span>
            <img>
        </div>
        <div class="c-bfslider__slide" data-bfslider="slide">
            <span>2</span>
            <img>>
        </div>
        <div class="c-bfslider__slide" data-bfslider="slide">
            <span>3</span>
            <img>
        </div>
    </div>
    <div class="c-bfslider-controls">
        <button class="c-bfslider-controls__item -left" data-bfslider="to-prev" aria-label="Élément précédent">
            <?php svg('arrow-full-left') ?>
        </button>
        <button class="c-bfslider-controls__item -right" data-bfslider="to-next" aria-label="Élément suivant">
            <?php svg('arrow-full-right') ?>
        </button>
    </div>
</div>
*/

// OPTIONS:

// data-bfslider-group="groupname" // sync slider with others
// data-bfslider-swipe="false" // Disable swipe (swipe enabled by default)
// data-bfslider-loop="false" // Disable loop (loop enabled by default)
// data-bfslider-nav="true" // Enable nav (bullets)
// data-bfslider-autoplay="4000" // Enable autoplay (delay in ms)